import { Skeleton, Stack } from "@mui/material";

// ----------------------------------------------------------------------

export const SkeletonPanel = () => {
	return (
		<Stack gap={2} sx={{ mt: 2 }}>
			<Skeleton variant='rectangular' height={100} sx={{ borderRadius: 1 }} />
			<Skeleton variant='rectangular' height={100} sx={{ borderRadius: 1 }} />
			<Skeleton variant='rectangular' height={100} sx={{ borderRadius: 1 }} />
		</Stack>
	);
};

export default SkeletonPanel;
